import { render, staticRenderFns } from "./ReversalModal.vue?vue&type=template&id=2863cf22&scoped=true"
import script from "./ReversalModal.vue?vue&type=script&lang=js"
export * from "./ReversalModal.vue?vue&type=script&lang=js"
import style0 from "./ReversalModal.vue?vue&type=style&index=0&id=2863cf22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2863cf22",
  null
  
)

export default component.exports